import type {RuleValidationErrors} from '../types';
import type {FileSizeRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateFileSizeRule = <T extends FileSizeRule = FileSizeRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (isNaN(rule.elementValue1) || rule.elementValue1.toString() === '') {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateFileSizeRule;
